'use es6';

import http from 'hub-http/clients/apiClient';
const COPY_API_BASE = 'cms-assets-file-copy/api/v1';
const THEMES_API_BASE = 'designmanager/v1/themes';
const THEME_EXTENSION_BASE = 'content/assets/v1/theme-extension';
export function getThemes() {
  return http.get(THEMES_API_BASE);
}
export function copyDefaultThemeByPath(themePath, {
  destinationFolderPath,
  label
}) {
  return http.post(`${COPY_API_BASE}/copy`, {
    data: {
      sourcePath: themePath,
      destinationPath: destinationFolderPath,
      label
    }
  });
}
export function createTheme({
  label,
  destinationFolderPath
}) {
  return http.post(`${THEMES_API_BASE}`, {
    data: {
      path: destinationFolderPath,
      name: label
    }
  });
}
export function createChildTheme(name, path, parentThemePath, jsPath, cssPath) {
  return http.post(`${THEME_EXTENSION_BASE}/async`, {
    data: {
      name,
      path,
      parentThemePath,
      jsPath,
      cssPath
    }
  });
}
export function getCreationStatus(creationId) {
  return http.get(`${THEME_EXTENSION_BASE}/async/status/${creationId}`);
}
export function getChildThemes(parentThemeName) {
  const themeName = encodeURIComponent(parentThemeName);
  return http.get(`${THEME_EXTENSION_BASE}/family/${themeName}`);
}
export function copyParentThemeFile(sourcePath, destinationPath) {
  return http.post(`${COPY_API_BASE}/copy/sync`, {
    data: {
      sourcePath,
      destinationPath
    }
  });
}